import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, Separator, Shimmer } from '@betterment/samba-react';

import { AdvisorResourcesCard } from './AdvisorResourcesCard';
import { ContactUsCard } from './ContactUsCard';
import { SupportPageDocument } from './graphql/query.supportPage.generated';

import { useCurrentAdvisor } from '../../hooks/useCurrentAdvisor';
import { Header } from '../BettermentForAdvisors/Header';
import { Layout } from '../InstitutionalApp/Layout';

const CardShimmer: React.FC = () => (
  <Card css={{ p: 'space.300' }}>
    <Card.Header>
      <Shimmer css={{ height: 'size.300', width: '50%', borderRadius: 'radius.100', mb: 'space.300' }} />
    </Card.Header>
    <Separator />
    <Card.Content>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200', mt: 'space.200' }}>
        <Shimmer css={{ height: 'size.200', borderRadius: 'radius.100' }} />
        <Shimmer css={{ height: 'size.200', width: '75%', borderRadius: 'radius.100' }} />
        <Shimmer css={{ height: 'size.200', width: '60%', borderRadius: 'radius.100' }} />
      </Box>
    </Card.Content>
  </Card>
);

export const SupportPage: React.FC = () => {
  const { data } = useGraphQLQuery(SupportPageDocument);
  const { currentAdvisor } = useCurrentAdvisor();
  const isFourOhOneKOnly = currentAdvisor?.firm.fourOhOneKOnly ?? false;

  return (
    <Layout active="support">
      <Layout.Header>
        <Header title="Support" />
      </Layout.Header>
      <Layout.Content>
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            alignItems: 'start',
            gap: 'space.400',
            '@media (max-width: 964px)': {
              gridTemplateColumns: '1fr',
            },
          }}
        >
          {data ? (
            <>
              <ContactUsCard support={data.support} isFourOhOneKOnly={isFourOhOneKOnly} />
              <AdvisorResourcesCard isFourOhOneKOnly={isFourOhOneKOnly} />
            </>
          ) : (
            <>
              <CardShimmer />
              <CardShimmer />
            </>
          )}
        </Box>
      </Layout.Content>
    </Layout>
  );
};
